import { memo } from 'react'

import Section2Title from './Section2Title'

const Section2TitleComponent = memo(Section2Title)
export default Section2TitleComponent
